@let reviewForm = form();
@let extraLinksArray = reviewForm.controls.extraLinks;
@let shouldShowError = extraLinksArray.errors?.extraLinksRequired;
@let hasDuplicateError = extraLinksArray.errors?.duplicateExtraLinks;

<div [formGroup]="reviewForm">
  <app-pan-form-control formArrayName="extraLinks" class="space-y-2">
    <app-pan-floating-label for="reports" [required]="isRequired()"> Video Clip of Incident (link) </app-pan-floating-label>
    <div class="space-y-2">
      @for (link of reviewForm.controls.extraLinks.controls; track link; let i = $index) {
        <div class="flex items-start gap-2">
          <div class="grow space-y-1">
            <input
              panInput
              [formControlName]="i"
              id="link-{{ i }}"
              placeholder="https://..."
              type="text"
              [attr.data-testid]="'link' + i"
              (blur)="trimExtraLink(i)"
            />
            @if (link.hasError("invalidLink")) {
              <div class="text-danger" role="alert" data-testid="invalidLinkError">Invalid link format</div>
            }
          </div>
          <button
            type="button"
            panButton
            icon="delete"
            color="danger"
            (click)="removeExtraLink(i)"
            [attr.aria-label]="'Remove link ' + (i + 1)"
            [attr.data-testid]="'removeLink-' + i"
          ></button>
        </div>
      }
    </div>
    @if (shouldShowError) {
      <div class="text-danger mb-2" role="alert" data-testid="extraLinksError">At least one video clip link is required.</div>
    }
    @if (hasDuplicateError) {
      <div class="text-danger mb-2" role="alert" data-testid="duplicateLinksError">
        Duplicate clips detected. Please remove duplicates before submitting.
      </div>
    }
    <button panButton (click)="addExtraLink()" icon="add" data-testid="addLink">Add another clip</button>
  </app-pan-form-control>
</div>
